import { call, all, put, takeLatest, select } from 'redux-saga/effects';
import api from '../../../services/api';
import {
  FETCH_SELECT_REQUEST,
  SEARCH_SELECT_FAILURE,
  SEARCH_SELECT_SUCCESS,
  SEARCH_SELECT_REQUEST
} from './select-pagination-constants';
import { appendSelectData, setSelectLoading } from './select-pagination-actions';
import { FetchSelectPayload, SearchSelectPayload, Action } from './select-pagination-interface';

const LIMIT = 10;
const LIMITSEARCH = 4000;

function* fetchSelect(action: Action<FetchSelectPayload>) {
  const { resource, skip = 0, limit = LIMIT, params = {} } = action.payload;
  try {
    yield put(setSelectLoading(resource, true));
    const response = yield call(api.get, `/${resource}`, { params: { limit, skip, ...params } });
    const items = response.data || [];
    const hasMore = items.length === limit;

    yield put(appendSelectData(resource, items, hasMore));
  } catch (e) {
    yield put(setSelectLoading(resource, false));
  }
}

function* searchSelect(action: Action<SearchSelectPayload>) {
  const { resource, searchTerm, limit = LIMITSEARCH, skip = 0, params = {} } = action.payload;
  try {
    yield put(setSelectLoading(resource, true));
    const response: any = yield call(api.get, `/${resource}`, {
      params: { queryString: searchTerm, limit, skip, ...params }
    });
    const items = response.data || [];
    const hasMore = items.length === limit;

    yield put(appendSelectData(resource, items, hasMore));
    yield put({
      type: SEARCH_SELECT_SUCCESS,
      payload: {
        resource,
        searchTerm
      }
    });
  } catch (e) {
    yield put({
      type: SEARCH_SELECT_FAILURE,
      payload: { resource, error: e }
    });
    yield put(setSelectLoading(resource, false));
  }
}

export default all([takeLatest(FETCH_SELECT_REQUEST, fetchSelect), takeLatest(SEARCH_SELECT_REQUEST, searchSelect)]);
